export default __webpack_public_path__ + "static/media/VixVizion.240432e1.svg";